import React from 'react'
import { Booking } from '../../components/Booking/Booking'

export const BookingContainer = () => {
  return (
    <Booking />
  )
}

